function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import React from "react";
import styles from "./ColorSelect.module.scss";
import colorRight from "./colorRight.png";
var ColorSelectModel = /*#__PURE__*/_createClass(function ColorSelectModel(color, isSelected) {
  _classCallCheck(this, ColorSelectModel);
  this.color = color;
  this.isSelected = isSelected;
});
export function ColorSelect() {
  var data = [new ColorSelectModel("#495436", true), new ColorSelectModel("#D3DADC", false), new ColorSelectModel("#12192B", false)];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.box
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.colorLabel
  }, "Color: ", /*#__PURE__*/React.createElement("span", {
    className: styles.colorValue
  }, "Forest Green"))), /*#__PURE__*/React.createElement("div", {
    className: styles.circleBox
  }, data.map(function (item) {
    return /*#__PURE__*/React.createElement("span", {
      key: item.color,
      className: styles.circle,
      style: {
        background: "".concat(item.color)
      }
    }, item.isSelected && /*#__PURE__*/React.createElement("img", {
      src: colorRight
    }));
  })));
}